import React from 'react';
import style from './secondaryPage.module.scss';
import propTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from 'tailwind-components/Button/Button';

function SecondaryPage({ children }) {
  const navigate = useNavigate();

  return (
    <div className={style.secondaryPage}>
      <div className={style.backArrow} onClick={() => navigate(-1)}>
        <Button
          text='Go back'
          vairant='secondary'
          size='small'
          icon={<ArrowLeft size={24} />}
        />
      </div>
      {children}
    </div>
  );
}

SecondaryPage.propTypes = {
  children: propTypes.element
};

export default SecondaryPage;
